<script>
import {
  layoutMethods,
  esellerMethods,
  digitalLoadMethods,
  erpUserRolesMethods
} from "@/state/helpers";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import ImageUploader from "@/components/ImageUploader";
import { getModuleAccess } from '@/router/helper.js'

/**
 * Add Network form component
 */
export default {
  page: {
    title: "Network Group Form",
  },
  data() {
    return {
      title: "Network Group Form",
      folder:"eload-network-image",
      networkId: 0,
      isEditModal: false,
      networkLogo: {
        filename: null,
        type: null,
        base64: null,
      },
      network: {
        id: null,
        name: "",
        image_src: "",
        status: 0,
        service: null,
        description: null
      },
      isSubmitted: false,
      submitProgress: '',
      formExitChecker: {
        id: null,
        name: "",
        image_src: "",
        status: 0,
        service: null,
        description: null
      },
      eloadServices: [],
      eloadNetworkGroupModule: {
        access: {
          create: true,
          update: true,
        }
      }
    };
  },
  components: {
    Multiselect,
    ImageUploader,
  },
  methods: {
    ...layoutMethods,
    ...esellerMethods,
    ...digitalLoadMethods,
    ...erpUserRolesMethods,
    checkForm() {
      this.isSubmitted = true;
      if (this.isEditModal) {
        this.updateNetwork();
      } else {
        this.createNetwork();
      }
    },
    clearLogo() {
      this.networkLogo = {
        filename: null,
        type: null,
        base64: null,
      };
    },
    createNetwork() {
      this.submitProgress = "Uploading Image"
      var networkObj = { ...this.network };
      delete networkObj.id;

      if (this.networkLogo.base64) {
        var networkLogo = { ...this.networkLogo };
        networkLogo.folder = this.folder;

        this.uploadLogo(networkLogo)
          .then((imageKey) => {
            networkObj = {
              ...networkObj,
              networkImageSrc: imageKey,
            };

           this.create(networkObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed101!", `${err}`, "error");
          });
      } else {
        this.create(networkObj);
      }
    },
    create(networkObj) {
      this.submitProgress = "Saving Network";
      console.log(">>> create this:", networkObj)
      if(networkObj.status =='' || networkObj.status == 0){
          networkObj.status = 'i'
      }else{
          networkObj.status = 'a'
      }
        this.actionNetworkGroup({
            action: "create",
            body: networkObj
        })
        .then(() => {
          this.submitProgress = "";
          this.isSubmitted = false;
          Swal.fire(
            "Create Successful!",
            `${networkObj.name} has been created.`,
            "success"
          );
          this.clearLogo();
          this.clearForm();
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "E-Load Network Group",
            }
          );
        })
        .catch((e) => {
          this.submitProgress = "";
          this.isSubmitted = false;
          console.log("Err::",e);
          Swal.fire(
            "Create Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${networkObj.name} was not created.`,
            "error"
          );
          this.clearLogo();
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    editNetwork(networkId) {
      this.logoPreview = null;
      this.getNetworkGroupInfo(networkId).then((itemData) => {
        for(let x of this.eloadServices){
          if(x["id"] == itemData["service_id"]){
            itemData["service"] = x;
            delete itemData.service_id;
          }
        }
        this.network = { ...itemData };
        this.formExitChecker = { ...itemData };
        if(this.network.status=='i'){
            this.network.status = 0
            this.formExitChecker.status = 0
        }
        else{
            this.network.status = 1
            this.formExitChecker.status = 1
        }
        this.isEditModal = true;
      });
    },
    updateNetwork() {
      var networkObj = { ...this.network };
      networkObj.id = networkObj.networkId;
      if(networkObj.status =='' || networkObj.status == 0){
          networkObj.status = 'i'
      }else{
          networkObj.status = 'a'
      }
      if (this.networkLogo.base64) {
        this.submitProgress = "Uploading Image"
        var networkLogo = { ...this.networkLogo };
        networkLogo.folder = this.folder;

        this.uploadLogo(networkLogo)
          .then((imageKey) => {
            networkObj = {
              ...networkObj,
              networkImageSrc: imageKey,
            };

            this.update(networkObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        networkObj.networkImageSrc = networkObj.image;
        this.update(networkObj);
      }
    },
    update(networkObj) {
      this.submitProgress = "Updating Network";
        this.actionNetworkGroup({
            action: "update",
            body: networkObj
        })
        .then(() => {
          // this.isEditModal = false;
          this.submitProgress = "";
          this.isSubmitted = false;
          Swal.fire(
            "Update Successful!",
            `${networkObj.name} has been updated.`,
            "success"
          );
          this.formExitChecker = this.network;
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "E-Load Network Group",
            }
          );
        })
        .catch((e) => {
          // this.isEditModal = false;
          this.submitProgress = "";
          this.isSubmitted = false;
          Swal.fire(
            "Update Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${networkObj.name} was not updated.`,
            "error"
          );
          this.clearLogo();
        });
    },
    leaveform(next){
        if(JSON.stringify(this.network) == JSON.stringify(this.formExitChecker)){
          next();
          return;
        } else {
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
        }

    },
    clearForm(){
      this.network = {
        id: null,
        name: "",
        image_src: "",
        status: 0
      };
      this.formExitChecker = this.network;
    }
  },
  async mounted() {
    this.actionNetworkGroup({
        action: "services",
        body: {}
    })
    .then((res) => {
        this.eloadServices = res.rows;
        this.networkId = this.$route.params.id;
        if (this.networkId > 0) {
          this.editNetwork(this.networkId);
          this.network.id = this.networkId
        }
        else {
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "E-Load Network Group",
            }
          );
          return;
        }
    })
    .catch((e) => {
        console.log(">>>> error while getting services:",e);
    });
    this.changeTitle({
      title: (this.networkId > 0 ? "Update" : "Add") + " Network Group",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'Digital Load', to: { name: 'Digital Load'} },
        { text: 'Network Group', to: { name: 'E-Load Network Group'} },
        { text: "Form", to: { name: "Network Form" } },
      ],
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'eLoad', 'eLoad Network Group')
      .then((access) => this.eloadNetworkGroupModule.access = access);

  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {
      console.log("><><><><> HEY",JSON.stringify(this.network),JSON.stringify(this.formExitChecker));
      // console.log(">> next:", next)
      this.leaveform(next);
  }
};
</script>

<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="pe-lg-2">
            <image-uploader
              :disabled="networkId > 0 ? !eloadNetworkGroupModule.access.update : !eloadNetworkGroupModule.access.create"
              class="me-4"
              v-model="networkLogo"
              :isRequired="true"
              :imageSrc="network.networkImageSrc"
            />
          </div>
          <!-- end of img upload-->
          
          <div class="px-lg-2">
            <div class="card">
              <div class="card-body" style="max-width: 620px">
                <div class="row">
                  <label v-if="(networkId <= 0 || isNaN(networkId)) && !eloadNetworkGroupModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a network.</label>
                  <label v-else-if="networkId > 0 && !eloadNetworkGroupModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a network.</label>
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        v-model="network.status"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexSwitchCheckDefault"
                        >Active</label
                      >
                    </div>
                  </div>
                  <!--end of network status-->

                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Network Name <span style="color: red">*</span></label>
                    <validation-provider
                      name="Network name"
                      rules="required"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Enter network name"
                        :state="getValidationState(validationContext)"
                        v-model="network.name"
                      />
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <!--end of network name-->

                  <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold">Service<span style="color: red">*</span></label>
                      <validation-provider
                        name="service"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          v-model="network.service"
                          :options="eloadServices"
                          track-by="id"
                          label="name"
                          name="name"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Service"
                          :allow-empty="true"
                          :preselect-first="false"
                          :class="{
                            invalid: errors[0],
                          }"
                        ></multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col><!--end of parent category-->

                  <!--end of network name-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Description</label>
                    <b-form-textarea
                        id="textarea"
                        placeholder="Description (optional)"
                        rows="2"
                        max-rows="4"
                        v-model="network.description"
                    ></b-form-textarea>
                  </div>


                  <div class="col-md-6 mt-3" v-if="!isSubmitted">
                    <b-button
                      :disabled="networkId > 0 ? !eloadNetworkGroupModule.access.update : !eloadNetworkGroupModule.access.create"
                      variant="primary"
                      class="w-sm w-100p"
                      type="submit"
                      >{{networkId > 0 ? 'Update':'Save'}}</b-button
                    >
                  </div>
                  <div class="col-md-6 mt-3" v-if="!isSubmitted">
                    <router-link
                      :to="{ name: 'E-Load Network Group', params: {} }"
                      class="tc-white"
                    >
                      <b-button
                        variant="light"
                        class="w-sm w-100p"
                        type="button"
                        >Cancel</b-button
                      >
                    </router-link>
                  </div>
                  <div class="col-md-6 mt-3" v-if="isSubmitted">
                    {{submitProgress}}
                  </div>
                </div>
              </div>
            </div>
            <!-- end of card-->
          </div>
          <!-- end of card form-->
        </div>
        <!--end of flex-->
      </b-form>
      <!-- end of the form--> </ValidationObserver
    ><!-- end of validation observer-->
  </div>
  <!-- end of row-->
</template>


<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}
</style>